import { FaRegSmile } from "react-icons/fa";
import classNames from "./EmojiPopover.module.css";
import * as Popover from "@radix-ui/react-popover";
import { useCallback, useState } from "react";
import { useLocalParticipant } from "@livekit/components-react";
import { useFloatingEmojis } from "../../../hooks/emoji";
import Button from "../../common/Button";

const encoder = new TextEncoder();

let emojis = ["❤️", "👍", "🎉", "👏", "😂", "😮", "😢", "🤔", "👎"];
// Halloween emojis
const today = new Date();
const month = today.getMonth();
const day = today.getDate();
if (month === 9 && day === 31) {
  emojis = ["🎃", "👻", "💀", "🕸️", "🕷️", "🧙‍♀️", "🧛‍♂️", "🍬", "🪦"];
}

export default function EmojiPopover() {
  const [isOpen, setIsOpen] = useState(false);
  const { showFloatingEmoji } = useFloatingEmojis();
  const { localParticipant } = useLocalParticipant();

  const sendEmojiReaction = useCallback(
    (emoji: string) => {
      showFloatingEmoji(emoji, "You");
      localParticipant.publishData(encoder.encode(emoji), { topic: "emoji" });
      setIsOpen(false);
    },
    [localParticipant, showFloatingEmoji]
  );

  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger className={classNames.EmojiPopoverTrigger} asChild>
        <Button
          color={isOpen ? "white" : "gray"}
          borderColor={isOpen ? "primary" : "dark-gray"}
          backgroundColor="black"
        >
          <FaRegSmile />
        </Button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className={classNames.EmojiPopoverContent}
          side="top"
          sideOffset={8}
        >
          {emojis.map((emoji, index) => (
            <div key={index} onClick={() => sendEmojiReaction(emoji)}>
              {emoji}
            </div>
          ))}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
